import FullInfoField from 'components/FullInfoField/FullInfoField';
import {
	CustomerFullInfoContext,
	ICustomerFullInfoContext,
} from 'modules/CustomersAndRestaurants/Customers/CustomerFullInfo/customerFullInfoState/customerFullInfoContext';
import React, { useContext } from 'react';
import moment from 'moment';

const FirmwareField: React.FC = () => {
	const { latestSoftwareUpdateData } = useContext<ICustomerFullInfoContext>(CustomerFullInfoContext);

	const inputValue = latestSoftwareUpdateData?.lastFimrwareAssignedDate
		? `${moment(latestSoftwareUpdateData.lastFimrwareAssignedDate).format('MM/DD/YYYY h:mm:ss A')} ${
				latestSoftwareUpdateData.lastFirmwareVersionName
		  }`
		: undefined;

	return <FullInfoField label="firmwareLabel" value={inputValue} />;
};

export default FirmwareField;
